module.exports = __webpack_public_path__ + "img/tintuc10.f21516ee.png";